export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex items-end justify-between mb-5">
      <div>
        <h1 className="font-display font-black text-2xl lg:text-3xl tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
      </div>
      {actions}
    </div>
  );
}

export function DataTable({ columns, rows, testid, onRowClick, empty = "No records" }) {
  return (
    <div className="border border-border rounded-sm overflow-hidden bg-card" data-testid={testid}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border bg-secondary">
              {columns.map((c) => (
                <th key={c.key} className="text-left label-caps px-3 py-2.5 whitespace-nowrap">
                  {c.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={columns.length} className="px-3 py-8 text-center text-muted-foreground">{empty}</td></tr>
            )}
            {rows.map((r, i) => (
              <tr
                key={r.id || i}
                onClick={() => onRowClick && onRowClick(r)}
                className={`border-b border-border/60 hover:bg-black/5 ${onRowClick ? "cursor-pointer" : ""}`}
              >
                {columns.map((c) => (
                  <td key={c.key} className="px-3 py-2 whitespace-nowrap">
                    {c.render ? c.render(r) : r[c.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function Pill({ children, color = "#71717A", bg }) {
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-sm text-xs font-semibold border"
          style={{ color, borderColor: color + "55", background: bg || color + "18" }}>
      {children}
    </span>
  );
}
